export default __webpack_public_path__ + "static/media/for-business-bus--rounded.fc3516be.svg";